import { parse as queryfilterFromString } from '@gonfalon/queryfilter/parser';

import type { UIContextsView } from '../types/types';

export function parseUIContextsViewFromBrowser(searchParams: URLSearchParams) {
  const ui: UIContextsView = {};
  const filter = searchParams.get('filter');
  if (filter) {
    const parse = queryfilterFromString(decodeURIComponent(filter));
    if (parse.ok) {
      ui.filter = parse.val;
    }
  }

  return ui;
}
